<script setup>
import ThemeToggle from '../shared/components/ThemeToggle.vue'
</script>

<template>
  <div class="auth-floating-controls">
    <ThemeToggle />
  </div>
</template>
